import { useEffect, useMemo } from 'react';
import { useOffersQuery } from '@gql/schema';
import * as Sentry from '@sentry/react';
import { useAppState } from '@utils/useAppState';
import { useApplicationState } from '@utils/useApplicationState';
import { notEmpty } from './AvailabilityPresentation.utils';

export const useOffers = () => {
  const { saleId } = useAppState();
  const { affiliateCode, territoryCode } = useApplicationState();

  const { data, error, loading, refetch } = useOffersQuery({
    variables: {
      saleId,
      affiliate: affiliateCode,
      territory: territoryCode,
    },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (error?.networkError) {
      Sentry.captureException(error.networkError);
    }
    error?.graphQLErrors.forEach(gqError => Sentry.captureException(gqError));
  }, [error]);

  const offers = useMemo(() => data?.sale?.offers?.filter(notEmpty) ?? [], [data]);

  return {
    offers,
    offersError: !!error,
    offersLoading: loading,
    offersRefetch: refetch,
  };
};
